import type { DepartmentPort, MemberPort } from '../domain/member'

const resolveDeptMemberIds = async (
	memberPort: MemberPort,
	deptPort: DepartmentPort,
	leaderId: string,
): Promise<string[]> => {
	const [allMembers, allDepts] = await Promise.all([
		memberPort.list({ q: null, status: null }),
		deptPort.listDepartments(),
	])

	const deptIds = new Set(
		allDepts
			.filter(d => d.departmentLeaderId === leaderId)
			.map(d => d.id),
	)

	return allMembers
		.filter(m => m.departmentId !== null && deptIds.has(m.departmentId))
		.map(m => m.id)
}

export { resolveDeptMemberIds }
